import React, { useEffect, useMemo, useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import TabsMui from '../layout/TabsMui'
import { MobileStatusChip } from '../components/mobile'
import ChargeDetailsTab from './ChargeDetailsTab'
import { layoutMobileMediaQuery } from '../layout/layoutConstants'
import {
  buildChargeTabs,
  CHARGE_STATUS_UI_MAP,
  CHARGE_TAB_VALUES
} from './chargeConstants'

const DEFAULT_TAB = CHARGE_TAB_VALUES.DETAILS

export default function ShowChargeView({ details, defaultDetails }) {
  const [activity, setActivity] = useState(defaultDetails)
  const [activeTab, setActiveTab] = useState(DEFAULT_TAB)
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)

  useEffect(() => {
    setActivity(defaultDetails)
  }, [defaultDetails])

  useEffect(() => {
    setActiveTab(DEFAULT_TAB)
  }, [activity?.uuid])

  const tabs = useMemo(() => buildChargeTabs(), [])
  const statusUI = CHARGE_STATUS_UI_MAP?.[activity?.status] || null

  if (!activity) return null

  return (
    <>
      <div className="main-show-header">
        <h2>Cobro: {activity?.charge_db_ref}</h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <div className="show-area-tabs-header">
            <TabsMui
              tabs={tabs}
              activeTab={activeTab}
              onChange={setActiveTab}
              scrollable={false}
              showDivider={false}
              marginBottom={0}
            />
            {!isMobileLayout && (
              <div className="status-orders">
                <b className="order-status-b">Estado:</b>
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                  <MobileStatusChip
                    statusUI={statusUI}
                    label={activity?.status || '-'}
                    sx={{
                      minHeight: 30,
                      '& .MuiChip-label': {
                        px: 1.5,
                        py: 0.35
                      }
                    }}
                  />
                </Box>
              </div>
            )}
          </div>

          <div className="tab-content-area">
            <ChargeDetailsTab
              activity={activity}
              transactionUuid={details?.uuid}
              activeTab={activeTab}
              statusUI={statusUI}
              showStatusInHeader={isMobileLayout}
            />
          </div>
        </div>
      </div>
    </>
  )
}
